<template>
	<div>

		<p>Nom
			<b-input @change="update" v-model="name"></b-input>
		</p>

		<div>Type : {{config.name || "libre" }}</div>

		<div v-for="(param, key) in config.get_data_params" :key="'g' + key">
			<p v-if="param.editable">
				{{param.title}}
				<ace_editor v-if="param.type == 'ace'" :code="param.value" @update="update_data($event, param)"></ace_editor>
				<array_editor v-else-if="param.type == 'array'" :start_data="param.value" @update="update_data($event, param)"></array_editor>
				<array_tag_editor v-else-if="param.type == 'array_tag'" :start_data="param.value" @update="update_data($event, param)"></array_tag_editor>
				<obj_editor v-else-if="param.type == 'object'" :start_data="param.value" @update="update_data($event, param)"></obj_editor>
				<span v-else-if="param.type == 'input_columns'">
					<br />
					<b-input v-model="param.value" style="display:inline; width: 90%"></b-input>
					<b-dropdown>
						<template #button-content>
							<i class="fas fa-plus"></i>
						</template> 
						<b-dropdown-item-button @click='param.value += (param.value.endsWith(" ") ? "" : " ") + "${data[\"" + column + "\"]}"' v-for="column in columns" :key="column">{{column}}</b-dropdown-item-button>
					</b-dropdown>
				</span>
				<b-input v-else :type="param.type" v-model="param.value"></b-input>			
			</p>
			<span v-if="param.previsualize">Prévisualisation : {{lodash.template(lodash.template(param.value)({data: import_data.length > 0 ? import_data[0] : {}, params: Object.fromEntries(Object.entries(config.get_data_params).map(([k, v]) => [k, v.value]))}))({data: import_data.length > 0 ? import_data[0] : {}, params: Object.fromEntries(Object.entries(config.get_data_params).map(([k, v]) => [k, v.value]))}) }}</span>
		</div>

		<div v-for="(param, key) in config.analyse_data_params" :key="'a' + key">
			<p v-if="param.editable">
				{{param.title}}
				<ace_editor v-if="param.type == 'ace'" :code="param.value" @update="update_data($event, param)"></ace_editor>
				<array_editor v-else-if="param.type == 'array'" :start_data="param.value" @update="update_data($event, param)"></array_editor>
				<array_tag_editor v-else-if="param.type == 'array_tag'" :start_data="param.value" @update="update_data($event, param)"></array_tag_editor>
				<obj_editor v-else-if="param.type == 'object'" :start_data="param.value" @update="update_data($event, param)"></obj_editor>
				<b-input v-else :type="param.type" v-model="param.value"></b-input>			
			</p>
		</div>

		<div v-for="(param, key) in config.visualize_data_params" :key="'e' + key">
			<p v-if="param.editable">
				{{param.title}}
				<ace_editor v-if="param.type == 'ace'" :code="param.value" @update="update_data($event, param)"></ace_editor>
				<array_editor v-else-if="param.type == 'array'" :start_data="param.value" @update="update_data($event, param)"></array_editor>
				<array_tag_editor v-else-if="param.type == 'array_tag'" :start_data="param.value" @update="update_data($event, param)"></array_tag_editor>
				<obj_editor v-else-if="param.type == 'object'" :start_data="param.value" @update="update_data($event, param)"></obj_editor>
				<b-input v-else :type="param.type" v-model="param.value"></b-input>			
			</p>
		</div>

		<div v-for="(param, key) in config.export_data_params" :key="'e' + key">
			<p v-if="param.editable">
				{{param.title}}
				<ace_editor v-if="param.type == 'ace'" :code="param.value" @update="update_data($event, param)"></ace_editor>
				<array_editor v-else-if="param.type == 'array'" :start_data="param.value" @update="update_data($event, param)"></array_editor>
				<array_tag_editor v-else-if="param.type == 'array_tag'" :start_data="param.value" @update="update_data($event, param)"></array_tag_editor>
				<obj_editor v-else-if="param.type == 'object'" :start_data="param.value" @update="update_data($event, param)"></obj_editor>
				<b-input v-else :type="param.type" v-model="param.value"></b-input>			
			</p>
		</div>

		<br /><b-button @click="test">Test sur 10 lignes</b-button><br /><br />

		<p>Résultats</p>

		<div v-if="config.visualize_data_params && config.visualize_data_params.visible && config.visualize_data_params.visible.value.length > 0">

			<b-button v-b-modal="'r-'+ id" >Résultats de la recherche</b-button> <br /><br />

			<b-modal :title="'Résultats'" size="xl" ok-only :id="'r-'+ id" static style="">
				<b-tabs>
					<b-tab :title="idx + 1 + ''" v-for="(result, idx) in data" :key="idx">
						<div v-for="(value, key) in result" :key="key + id">
							<div v-if="config.visualize_data_params.columns.value.includes(key)">
								<b>{{key}}</b>
								<draggable :group="'c-' + key + '-' + idx" :list="value" class="list-group" handle=".handle">
									<b-card v-for="(sub_value, sub_idx) in value" :key="'s' + sub_idx + id" style="">
										<div v-for="(_value, sub_key) in sub_value" :key="'v'+sub_key + id">
											<b>{{sub_key}}:</b> {{_value}}
										</div>
										<b-button variant="link" class="handle"><i class="fas fa-arrows-alt"></i></b-button>
									</b-card>
								</draggable>
							</div>
							<div v-else>
								<b>{{key}}:</b> {{value}}
							</div>
						</div>
					</b-tab>
				</b-tabs>
				<b-button @click="export_csv" variant="link" >Export</b-button> <br />
			</b-modal>
		</div>

		<edit_tabulator ref="tabulator" :extern_file="false"></edit_tabulator>

		<div v-if="spinner" class="center_spinner">
			<fade-loader></fade-loader>
		</div>
	</div>
</template>

<script>
    import lodash from 'lodash';
	import * as json2csv from "json2csv";
	import draggable from "vuedraggable";
	import uniqueId from "lodash.uniqueid";
    import FadeLoader from "vue-spinner/src/FadeLoader.vue";

	var clone = require("clone");
	var jp = require('jsonpath');

	import obj_editor from "./obj_editor.vue";
	import ace_editor from "./ace_editor.vue";
	import library from "../services/library.js";
	import workers from "../services/workers.js";
    import array_editor from "./array_editor.vue";
	import edit_tabulator from "./edit_tabulator.vue";
    import treatments from "../services/treatments.js";
	import utils_treatments from "../utils/treatment.js";
    import array_tag_editor from "./array_tag_editor.vue";

	export default {
		name: "characteristic",
		components: {
			edit_tabulator,
			draggable,
			FadeLoader,
			ace_editor,
			array_editor,
			obj_editor,
			array_tag_editor
		},
		props: {
		},
		data() {
			return {
				name: "Caratéristique",
				id: uniqueId(""),
				type: {},
				config: {},
				import_data: [],
				columns: [],
				data: [],
				spinner: false,
				lodash: lodash
			};
		},
		watch: {
			import_data: {
				deep: true,
				handler: function (newVal, oldVal) {
					//console.log("import_data")
					this.columns = this.import_data.length > 0 ? Object.keys(this.import_data[0]) : []
				}
			}
		},
		methods: {
			update()
			{
				this.$emit("update", {
					type: this.type,
					config: this.config,
					name: this.name
				});
			},
			get_steps()
			{
				var self = this;

				var steps = [];

				var labels = {
					fonction: "Script personnalisé",
					api: "API"
				}

				var get_parameters = clone(this.config.get_data_step.parameters);
				
				var keys = Object.keys(this.config.get_data_params);
				for (var i = 0; i < keys.length; i++)
				{
					if (self.config.get_data_params[keys[i]].type == "number" && typeof self.config.get_data_params[keys[i]].value == "string")
						self.config.get_data_params[keys[i]].value = parseFloat(self.config.get_data_params[keys[i]].value);
					if (this.config.get_data_params[keys[i]].jsonpath)
						jp.apply(get_parameters, this.config.get_data_params[keys[i]].jsonpath, function(value) { return self.config.get_data_params[keys[i]].value })
				}

				steps.push({
					"data": {
						"action": this.config.get_data_step.action,
						"label": labels[this.config.get_data_step.action],
						"parameters": get_parameters,
					},
					"description": "Carac " + this.config.name + " - get",
					"action": this.config.get_data_step.action,
					"actionLabel": labels[this.config.get_data_step.action],
					"c_conditions": true,
					"c_tree": false,
					"c_project": false,
					"project_id": "",
					"c_parameters": true,
					"c_tabulator": false,
					"c_test": true,
					"tabulator2": [],
					"keep_start_data": false,
					"option_delete": false,
					"option_make_list": false,
					"treatment": false,
					"source_data": "",
					"currentRequest": null
				});

				var analyse_parameters = clone(this.config.analyse_data_step.parameters);
				
				var keys = Object.keys(this.config.analyse_data_params);
				for (var i = 0; i < keys.length; i++)
				{
					if (self.config.analyse_data_params[keys[i]].type == "number" && typeof self.config.analyse_data_params[keys[i]].value == "string")
						self.config.analyse_data_params[keys[i]].value = parseFloat(self.config.analyse_data_params[keys[i]].value);
					if (this.config.analyse_data_params[keys[i]].jsonpath)
						jp.apply(analyse_parameters, this.config.analyse_data_params[keys[i]].jsonpath, function(value) { return self.config.analyse_data_params[keys[i]].value })
				}

				analyse_parameters.parameters.column_source = this.config.get_data_params.column_result.value;
				analyse_parameters.parameters.get_parameters = get_parameters;

				steps.push({
					"data": {
						"action": this.config.analyse_data_step.action,
						"label": labels[this.config.analyse_data_step.action],
						"parameters": analyse_parameters,
					},
					"description": "Carac " + this.config.name + " - analyse",
					"action": this.config.analyse_data_step.action,
					"actionLabel": labels[this.config.analyse_data_step.action],
					"c_conditions": true,
					"c_tree": false,
					"c_project": false,
					"project_id": "",
					"c_parameters": true,
					"c_tabulator": false,
					"c_test": true,
					"tabulator2": [],
					"keep_start_data": false,
					"option_delete": false,
					"option_make_list": false,
					"treatment": false,
					"source_data": "",
					"currentRequest": null
				});

				var export_parameters = this.config.export_data_step.parameters;
				
				var keys = Object.keys(this.config.export_data_params);
				for (var i = 0; i < keys.length; i++)
				{
					if (self.config.export_data_params[keys[i]].type == "number" && typeof self.config.export_data_params[keys[i]].value == "string")
						self.config.export_data_params[keys[i]].value = parseFloat(self.config.export_data_params[keys[i]].value);
					if (this.config.export_data_params[keys[i]].jsonpath)
						jp.apply(export_parameters, this.config.export_data_params[keys[i]].jsonpath, function(value) { return self.config.export_data_params[keys[i]].value })
				}

				export_parameters.parameters.column_source = this.config.analyse_data_params.column_result.value;
				export_parameters.parameters.get_parameters = get_parameters;
				export_parameters.parameters.analyse_parameters = analyse_parameters;

				steps.push({
					"data": {
						"action": this.config.export_data_step.action,
						"label": labels[this.config.export_data_step.action],
						"parameters": export_parameters,
					},
					"description": "Carac " + this.config.name + " - export",
					"action": this.config.export_data_step.action,
					"actionLabel": labels[this.config.export_data_step.action],
					"c_conditions": true,
					"c_tree": false,
					"c_project": false,
					"project_id": "",
					"c_parameters": true,
					"c_tabulator": false,
					"c_test": true,
					"tabulator2": [],
					"keep_start_data": false,
					"option_delete": false,
					"option_make_list": false,
					"treatment": false,
					"source_data": "",
					"currentRequest": null
				});

				return steps;
			},
			async update_data(data, param)
			{
				param.value = data;
			},
			async load(data)
			{
				var self = this;

				this.config = data.config;
				this.type = data.type;
				if (data.name)
					this.name = data.name;
			},
			async save()
			{	
				return {
					type: this.type,
					config: this.config,
					name: this.name
				}
			},
			async refresh_config()
			{
				var result = await library.load(
					this.type,
					null,
					"config_characteristic"
				);

				//console.log(result)

				var old_config = clone(this.config);

				this.config = result;

				var keys = Object.keys(this.config.get_data_params);
				for (var i = 0; i < keys.length; i++)
				{
					if (old_config.get_data_params[keys[i]] && this.config.get_data_params[keys[i]].editable)
						this.config.get_data_params[keys[i]].value = old_config.get_data_params[keys[i]].value;
				}

				var keys = Object.keys(this.config.analyse_data_params);
				for (var i = 0; i < keys.length; i++)
				{
					if (old_config.analyse_data_params[keys[i]] && this.config.analyse_data_params[keys[i]].editable)
						this.config.analyse_data_params[keys[i]].value = old_config.analyse_data_params[keys[i]].value;
				}

				var keys = Object.keys(this.config.visualize_data_params);
				for (var i = 0; i < keys.length; i++)
				{
					if (old_config.visualize_data_params[keys[i]] && this.config.visualize_data_params[keys[i]].editable)
						this.config.visualize_data_params[keys[i]].value = old_config.visualize_data_params[keys[i]].value;
				}

				var keys = Object.keys(this.config.export_data_params);
				for (var i = 0; i < keys.length; i++)
				{
					if (old_config.export_data_params[keys[i]] && this.config.export_data_params[keys[i]].editable)
						this.config.export_data_params[keys[i]].value = old_config.export_data_params[keys[i]].value;
				}

			},
			async test()
			{
				var self = this;
				this.spinner = true;

				// get

                this.data = [];

				var data = clone(this.import_data);

                var str_csv = json2csv.parse(data, {
					fields: Object.keys(data[0]),
					fieldNames: Object.keys(data[0]),
				});

				var files = [
					new File([str_csv], "data.csv", {
						type: "text/csv",
					}),
				];

				var formData = new FormData();
				formData.append(files[0].name, files[0], "data.csv");
				formData.append("action", this.config.get_data_step.action);

				var get_parameters = clone(this.config.get_data_step.parameters);
				
				var keys = Object.keys(this.config.get_data_params);
				for (var i = 0; i < keys.length; i++)
				{
					if (self.config.get_data_params[keys[i]].type == "number" && typeof self.config.get_data_params[keys[i]].value == "string")
						self.config.get_data_params[keys[i]].value = parseFloat(self.config.get_data_params[keys[i]].value);
					if (this.config.get_data_params[keys[i]].jsonpath)
						jp.apply(get_parameters, this.config.get_data_params[keys[i]].jsonpath, function(value) { return self.config.get_data_params[keys[i]].value })
				}

				this.get_parameters = get_parameters;

                formData.append("parameters", JSON.stringify(get_parameters));

                var results = await workers.test(formData);

                var data = await treatments.getFileAlyx(
					results.data.files[0].url,
					false,
					"arraybuffer"
				);
				var fileName = results.data.files[0].name;
                
				console.log("analye")

				// analyse

				var files = [
					new File([data], "data.csv", {
						type: "text/csv",
					}),
				];

				var formData = new FormData();
				formData.append(files[0].name, files[0], "data.csv");
				formData.append("action", this.config.analyse_data_step.action);

				var analyse_parameters = clone(this.config.analyse_data_step.parameters);
				
				var keys = Object.keys(this.config.analyse_data_params);
				for (var i = 0; i < keys.length; i++)
				{
					if (self.config.analyse_data_params[keys[i]].type == "number" && typeof self.config.analyse_data_params[keys[i]].value == "string")
						self.config.analyse_data_params[keys[i]].value = parseFloat(self.config.analyse_data_params[keys[i]].value);
					if (this.config.analyse_data_params[keys[i]].jsonpath)
						jp.apply(analyse_parameters, this.config.analyse_data_params[keys[i]].jsonpath, function(value) { return self.config.analyse_data_params[keys[i]].value })
				}

				analyse_parameters.parameters.column_source = this.config.get_data_params.column_result.value;
				analyse_parameters.parameters.get_parameters = get_parameters;
				this.analyse_parameters = analyse_parameters;

                formData.append("parameters", JSON.stringify(analyse_parameters));

                var results = await workers.test(formData);

                var data = await treatments.getFileAlyx(
					results.data.files[0].url,
					false,
					false
				);
				var fileName = results.data.files[0].name;
                
                data = this.$papa.parse(data, { header: true });

				this.data = data.data;
				
				console.log(this.data);

				for (var i = 0; i < this.data.length; i++)
				{
					for (var j = 0; j < this.config.visualize_data_params.columns.value.length; j++)
					{
						try
						{
							if (this.data[i][this.config.visualize_data_params.columns.value[j]])
								this.data[i][this.config.visualize_data_params.columns.value[j]] = JSON.parse(this.data[i][this.config.visualize_data_params.columns.value[j]])
						}
						catch (err) {}
					}
				}
				this.spinner = false;

				var data = await this.export_csv();
				return data;
			},
			async export_csv()
			{
				if (this.data.length == 0)
					await this.test();

				this.spinner = true;
				var self = this;

				var data = clone(this.data);

                var str_csv = json2csv.parse(data, {
					fields: Object.keys(data[0]),
					fieldNames: Object.keys(data[0]),
				});

				var files = [
					new File([str_csv], "data.csv", {
						type: "text/csv",
					}),
				];

				var formData = new FormData();
				formData.append(files[0].name, files[0], "data.csv");
				formData.append("action", this.config.export_data_step.action);

				var export_parameters = this.config.export_data_step.parameters;
				
				var keys = Object.keys(this.config.export_data_params);
				for (var i = 0; i < keys.length; i++)
				{
					if (self.config.export_data_params[keys[i]].type == "number" && typeof self.config.export_data_params[keys[i]].value == "string")
						self.config.export_data_params[keys[i]].value = parseFloat(self.config.export_data_params[keys[i]].value);
					if (this.config.export_data_params[keys[i]].jsonpath)
						jp.apply(export_parameters, this.config.export_data_params[keys[i]].jsonpath, function(value) { return self.config.export_data_params[keys[i]].value })
				}

				export_parameters.parameters.column_source = this.config.analyse_data_params.column_result.value;
				export_parameters.parameters.get_parameters = this.get_parameters;
				export_parameters.parameters.analyse_parameters = this.analyse_parameters;

				formData.append("parameters", JSON.stringify(export_parameters));
				
				var results = await workers.test(formData);

                var data = await treatments.getFileAlyx(
					results.data.files[0].url,
					false,
					false
				);
				var fileName = results.data.files[0].name;
				
				data = this.$papa.parse(data, { header: true });
				data = data.data;
				
				this.$refs.tabulator.set_data(data);
				this.spinner = false;

				return data;
			},
			async set_import_data(data)
			{
				this.import_data = clone(data);
			},
			async get_data()
			{
				return clone(this.data);
			}
		},
		mounted: async function () {
		},
	};
</script>

<style scoped>
	.center_spinner {
		width: 0%;
		margin: 0 auto;
        margin-bottom: 60px;
	}
    .table-striped > tbody > tr:nth-child(2n+1) > td, .table-striped > tbody > tr:nth-child(2n+1) > th {
        background-color: WhiteSmoke;
    }
	::v-deep .dropdown-menu {
		max-height: 300px;
		overflow-y: auto;
	}
</style>